import { AxiosResponse } from 'axios'
import { request } from '../request'
import { BillingAccountDTO } from '@models/api/BillingAccountDTO'
import { PaymentMethodDTO } from '@models/api/PaymentMethodDTO'
import { PaymentSubscriptionDTO } from '@models/api/PaymentSubscriptionDTO'
import { InvoiceDTO } from '@models/api/InvoiceDTO'

export const stripe = {
  getBillingAccount: function (): Promise<AxiosResponse<BillingAccountDTO>> {
    return request.get('account/billingAccount')
  },

  getPaymentMethods: function (): Promise<AxiosResponse<PaymentMethodDTO[]>> {
    return request.get('account/paymentMethod')
  },

  getSubscription: function (): Promise<AxiosResponse<PaymentSubscriptionDTO>> {
    return request.get('account/subscription')
  },

  getInvoices: function (): Promise<AxiosResponse<InvoiceDTO>> {
    return request.get('account/invoices')
  },

  getEditPaymentMethodURL: function (): Promise<AxiosResponse<string>> {
    return request.get('stripe/subscription/manage/payment-method')
  },
  getEditBillingAccountURL: function (): Promise<AxiosResponse<string>> {
    return request.get('stripe/subscription/manage/address')
  }
}
